import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import devices from "./devices";
import { State as DeviceState } from "./devices/state";
import { Getters as DeviceGetters } from "./devices/getters";

import recoveryAgent from "./recovery-agent";
import { State as RecoveryAgentState } from "./recovery-agent/state";
import { Getters as RecoveryAgentGetters } from "./recovery-agent/getters";

export interface RootState {
  device: DeviceState;
  recoveryAgent: RecoveryAgentState;
}

export type Getters = DeviceGetters & RecoveryAgentGetters;

const store = new Vuex.Store<RootState>({
  modules: {
    device: devices,
    recoveryAgent
  },
  plugins: []
});

export default store;
